// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"79":"08914911","378":"08914911","462":"08914911","611":"08914911","654":"08914911","726":"08914911","798":"08914911","806":"08914911","836":"08914911","945":"08914911"}[chunkId] + ".chunk.css";
};